import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, ChevronRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const products = [
    { name: "Industrial RO Plants", path: "/products?category=RO Plants" },
    { name: "Effluent Treatment Plants", path: "/products?category=Treatment Plants" },
    { name: "Water Softeners", path: "/products?category=Water Softeners" },
    { name: "Water Chillers", path: "/products?category=Coolers & Chillers" },
    { name: "DM Plants", path: "/products" },
  ];

  const quickLinks = [
    { name: "About Us", path: "/about" },
    { name: "Our Services", path: "/services" },
    { name: "Products", path: "/products" },
    { name: "Blog", path: "/blog" },
    { name: "Contact Us", path: "/contact" },
  ];

  return (
    <footer className="footer-gradient text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="/logo-hd.png" 
                alt="VIVID - We restore purity" 
                className="h-16 w-auto bg-white rounded-lg p-2"
              />
            </div>
            <p className="text-blue-100 text-sm leading-relaxed mb-6">
              Leading manufacturer and supplier of industrial water treatment solutions. 
              Trusted by industries across India since 2014.
            </p>
            <div className="flex gap-3">
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/vividh2osolutions/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-blue-500 transition-colors"
                title="Visit our Facebook page"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              {/* LinkedIn */}
              <a 
                href="https://www.linkedin.com/in/vivid-h2o-solutions-092a583b9/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                title="Visit our LinkedIn profile"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/vividh2osolutions?igsh=eDNrczVvejR1bWFk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors"
                title="Visit our Instagram profile"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              {/* WhatsApp */}
              <a 
                href="https://wa.me/918770828302" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-green-500 transition-colors"
                title="Chat with us on WhatsApp"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.272-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.67-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421-7.403h-.004a9.87 9.87 0 00-4.782 1.176l-.341.197-3.52.962.979-3.57-.235-.374a9.86 9.86 0 011.516-4.383A9.982 9.982 0 0112 0c5.483 0 9.967 4.461 9.967 9.933 0 5.473-4.461 9.967-9.933 9.967-1.635 0-3.22-.379-4.646-1.11l-.355-.187-3.639.988.997-3.645-.161-.326a9.933 9.933 0 01-1.562-5.32zm8.905-7.773c-.868 0-1.716.206-2.522.611-3.022 1.498-4.968 4.627-4.968 8.093 0 5.231 4.25 9.481 9.481 9.481.974 0 1.926-.154 2.838-.454 3.022-.997 5.573-3.729 6.334-7.246.454-2.048.454-4.187-.007-6.286-.763-3.516-3.281-6.248-6.303-7.247-1.002-.383-2.036-.492-3.053-.452z"/></svg>
              </a>
              {/* Google My Business */}
              <a 
                href="https://share.google/YPOUGKDziu7kImwPx" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-yellow-500 transition-colors"
                title="Visit our Google Business profile"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12 12-5.373 12-12S18.628 0 12 0zm5.521 6.465a4.996 4.996 0 011.482 5.027c-.135.609-.36 1.194-.666 1.738H15.75v-3.752h3.688a8.996 8.996 0 00-1.917-2.013zm-2.521 10.535v-3.75h6.254c-.282.781-.754 1.5-1.382 2.104-1.352 1.315-3.193 2.122-5.218 2.148a7 7 0 01.346-.502zM12 18a5.996 5.996 0 01-3.75-1.276V12.75H4.75a6 6 0 016-6 5.994 5.994 0 013.75 1.275v4.25H8.125a.625.625 0 00-.625.625v3.125A5.988 5.988 0 0112 18z"/></svg>
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Our Products</h3>
            <ul className="space-y-3">
              {products.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    className="text-blue-100 text-sm hover:text-white flex items-center gap-2 transition-colors"
                  >
                    <ChevronRight className="w-4 h-4 text-cyan-300" />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.path} 
                    className="text-blue-100 text-sm hover:text-white flex items-center gap-2 transition-colors"
                  >
                    <ChevronRight className="w-4 h-4 text-cyan-300" />
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-cyan-300" />
                </div>
                <span className="text-blue-100 text-sm">
                  C-125, Vidhya Nagar,<br />
                  Hoshangabad Road, Bhopal - 462026
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-cyan-300" />
                </div>
                <div className="flex flex-col gap-1">
                  <a href="tel:+918770828302" className="text-blue-100 text-sm hover:text-white transition-colors">
                    +91-8770828302
                  </a>
                  <a href="tel:+919303772139" className="text-blue-100 text-sm hover:text-white transition-colors">
                    +91-9303772139
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-cyan-300" />
                </div>
                <a href="mailto:vividh2osolutions@gmail.com" className="text-blue-100 text-sm hover:text-white transition-colors">
                  vividh2osolutions@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5 text-cyan-300" />
                </div>
                <span className="text-blue-100 text-sm">
                  Mon - Sat: 10:00 AM - 7:00 PM
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-blue-200 text-sm">
            © {currentYear} VIVID®. All rights reserved.
          </p>
          <p className="text-blue-200 text-sm">
            GST: 23CCQPS3136K1Z7 | Est. 2017
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
